import Vue from 'vue';
import Vuex from 'vuex';
import persistedState from 'vuex-persistedstate';
import i18n from '@/lang/lang';
import users from './modules/users';
import leaderboard from './modules/leaderboard';
import transactions from './modules/transactions';
import exchanges from './modules/exchanges';
import notifications from './modules/notifications';
import histories from './modules/histories';
import socialNetworks from './modules/socialNetworks';
import payments from './modules/payments';
import reports from './modules/reports';
import companies from './modules/companies';
import kudos from './modules/kudos';


Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

let defaultApiKey;
try {
    const queryString = window.location.search;
    if (queryString) {
        const urlParams = new URLSearchParams(queryString);
        if (urlParams) {
            defaultApiKey = urlParams.get('motid');
        }
    }
} catch (e) {
    // eslint-disable-next-line no-console
    console.log('Failed to reauth:', e);
}


const store = new Vuex.Store({
    state: {
        apiKey: defaultApiKey,
    },
    mutations: {
        storeApiKey(state, apiKey) {
            console.log('store', apiKey);
            state.apiKey = apiKey;
        },
        setTutorialSeen(state) {
            state.tutorialSeen = true;
        },
        changeLocale(state, locale) {
            state.locale = locale;
        },
    },
    getters: {
        hasApiKey: state => state.apiKey !== undefined && state.apiKey !== null && state.apiKey !== '' && state.apiKey !== ' ',
        apiKey: state => state.apiKey,
        tutorialSeen: state => state.tutorialSeen,
        locale: state => state.locale || i18n.locale,
    },
    modules: {
        users,
        leaderboard,
        transactions,
        exchanges,
        notifications,
        histories,
        socialNetworks,
        payments,
        reports,
        companies,
        kudos,
    },
    strict: debug,
    plugins: [persistedState({
        key: 'store',
        paths: [
            'apiKey',
            'tutorialSeen',
            'users.loggedInUserProfile',
            'locale',
        ],
    })],
});

export default store;
